import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getPrecio } from "../../actions/precio";
import { SimboloMoneda } from "./SimboloMoneda";

export class Precio extends Component {
  state = {};

  static propTypes = {
    precio: PropTypes.object.isRequired,
    getPrecio: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (this.props.precio[this.props.codigo_articulo] === undefined) {
      this.props.getPrecio(
        this.props.codigo_articulo,
        this.props.auth.hash != null ? this.props.auth.hash : ""
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.precio[this.props.codigo_articulo] === undefined) {
      if (prevProps.codigo_articulo !== this.props.codigo_articulo) {
        this.props.getPrecio(
          this.props.codigo_articulo,
          this.props.auth.hash != null ? this.props.auth.hash : ""
        );
      }
    }
  }

  render() {
    if (
      this.props.precio[this.props.codigo_articulo] === undefined ||
      this.props.precio[this.props.codigo_articulo].isLoading
    ) {
      return (
        <Fragment>
          <img
            className="loader-precio"
            src="/assets/img/loader2.gif"
            data-src="/assets/img/loader2.gif"
            alt="Cargando..."
          />
        </Fragment>
      );
    } else if (this.props.precio[this.props.codigo_articulo].error) {
      return (
        <Fragment>
          <span>Precio no disponible</span>
        </Fragment>
      );
    } else if (this.props.precio_manual !== undefined) {
      return (
        <Fragment>
          <span>
            {this.props.precio[this.props.codigo_articulo].data.precio_neto
              ? new Intl.NumberFormat(this.props.locale, {
                  style: "currency",
                  currency: this.props.precio[this.props.codigo_articulo].data
                    .divisa_precio,
                }).format(
                  Number.parseFloat(this.props.precio_manual).toFixed(2)
                )
              : ""}
            {!Array.isArray(
              this.props.precio[this.props.codigo_articulo].data
                .impuesto_articulo
            )
              ? " + " +
                this.props.precio[this.props.codigo_articulo].data
                  .impuesto_articulo +
                "% IVA"
              : ""}
            {typeof this.props.precio[this.props.codigo_articulo]
              .presentacion === "string" &&
            this.props.precio[this.props.codigo_articulo].data.presentacion !==
              ""
              ? "/" +
                this.props.precio[this.props.codigo_articulo].data.presentacion
              : ""}
          </span>
        </Fragment>
      );
    } else if (this.props.precio[this.props.codigo_articulo] !== undefined) {
      return (
        <Fragment>
          <meta
            itemProp="priceCurrency"
            content={
              this.props.precio[this.props.codigo_articulo].data.divisa_precio
            }
          />
          <meta
            itemProp="price"
            content={Number.parseFloat(
              this.props.precio[this.props.codigo_articulo].data.precio_neto /
                this.props.precio[this.props.codigo_articulo].data
                  .cantidad_precio
            ).toFixed(2)}
          />
          <span>
            {this.props.precio[this.props.codigo_articulo].data.precio_neto
              ? new Intl.NumberFormat(this.props.locale, {
                  style: "currency",
                  currency: this.props.precio[this.props.codigo_articulo].data
                    .divisa_precio,
                }).format(
                  Number.parseFloat(
                    this.props.precio[this.props.codigo_articulo].data
                      .precio_neto /
                      this.props.precio[this.props.codigo_articulo].data
                        .cantidad_precio
                  ).toFixed(2)
                )
              : ""}
            {!Array.isArray(
              this.props.precio[this.props.codigo_articulo].data
                .impuesto_articulo
            )
              ? " + " +
                this.props.precio[this.props.codigo_articulo].data
                  .impuesto_articulo +
                "% IVA"
              : ""}
            {typeof this.props.precio[this.props.codigo_articulo]
              .presentacion === "string" &&
            this.props.precio[this.props.codigo_articulo].data.presentacion !==
              ""
              ? "/" +
                this.props.precio[this.props.codigo_articulo].data.presentacion
              : ""}
          </span>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  precio: state.precio.precio,
  locale: state.precio.locale,
  auth: state.auth,
});

export default connect(mapStateToProps, { getPrecio })(Precio);
